export * from './coparticipation.service';
